<script lang="ts" setup>
import { CATALOG_FILTER_TYPES } from '~/constants/catalogFilterTypes';
import type { Filter } from '~/types/Catalog';

const isOpen = defineModel<boolean>('isOpen', { default: true });
const props = defineProps<{ filter: Filter }>();

const activeOptionsCount = computed(() => {
  switch (props.filter.type) {
    case CATALOG_FILTER_TYPES.RANGE:
      return Number(props.filter.details.state);
    case CATALOG_FILTER_TYPES.CHECKBOX:
    case CATALOG_FILTER_TYPES.RADIO:
      return props.filter.options.filter((o) => o.state).length;
    case CATALOG_FILTER_TYPES.NUMERIC:
      return !!props.filter.value ? 1 : 0;
    default:
      return 0;
  }
});
</script>

<template>
  <div class="filter-item">
    <button
      class="flex justify-between items-center gap-2 font-bold"
      @click="isOpen = !isOpen"
    >
      <div class="text-start">
        {{ filter.title === 'БазовыйЦвет' ? 'Цвет' : filter.title }}
      </div>

      <SvgoChevronDown
        :class="{ 'rotate-180': isOpen }"
        filled
      />
    </button>

    <FoldableBlock v-model="isOpen">
      <div class="py-2">
        <CheckboxFilter
          v-if="filter.type === CATALOG_FILTER_TYPES.CHECKBOX"
          :filter
        />

        <RadioFilter
          v-else-if="filter.type === CATALOG_FILTER_TYPES.RADIO"
          :filter
        />

        <RangeFilter
          v-else-if="filter.type === CATALOG_FILTER_TYPES.RANGE"
          :filter
        />

        <NumericFilter
          v-else-if="filter.type === CATALOG_FILTER_TYPES.NUMERIC"
          :filter
        />
      </div>
    </FoldableBlock>
  </div>
</template>

<style lang="scss" scoped>
.filter-item {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__active-count {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    border-radius: 999px;
    background-color: $accent;
    color: $white;
    font-size: $text-xs;
  }
}
</style>
